import clsx from 'clsx';
import React from 'react';

import classes from './SelectableTag.module.scss';

type SelectableTagProps = React.PropsWithChildren<{
    selected?: boolean;
    onClick?: () => void;
    className?: string;
}>;

export const SelectableTag: React.FC<SelectableTagProps> = props => {
    return (
        <div
            className={clsx(classes.root, props.className, {
                [classes.selected]: props.selected
            })}
            onClick={props.onClick}
        >
            <span>{props.children}</span>
        </div>
    );
};
